export interface AdvertiserRequest {
  id: number;
  advertiserName: string;
  companyName: string;
  category: string;
  location: string;
  budget: number;
  budgetType: string;
  description: string;
  targetAudience: string;
  preferredFormat: string;
  duration: string;
  startDate: string;
  status: string;
  postedDate: string;
  proposals: number;
  contactEmail: string;
  contactPhone: string;
}

export type RequestStatus = 'todas' | 'nueva' | 'analizando' | 'propuesta-enviada' | 'cerrada';
export type BudgetRange = 'todos' | 'menos-500' | '500-1500' | '1500-3000' | 'mas-3000';

export const advertiserRequests: AdvertiserRequest[] = [
  {
    id: 1,
    advertiserName: 'Martín Gutiérrez',
    companyName: 'Cerveza Andes',
    category: 'Bebidas',
    location: 'Mendoza',
    budget: 800,
    budgetType: 'mensual',
    description: 'Buscamos presencia en radio local para campaña de verano. Necesitamos menciones en vivo y presencia en eventos de la radio. Público objetivo: jóvenes 20-35 años.',
    targetAudience: 'Jóvenes 20-35, Mendoza y alrededores',
    preferredFormat: 'Menciones en vivo + Eventos',
    duration: '3 meses',
    startDate: '2026-07-01',
    status: 'nueva',
    postedDate: '2026-06-18',
    proposals: 0,
    contactEmail: 'martin@cervezandes.com',
    contactPhone: '+54 261 555-0101',
  },
  {
    id: 2,
    advertiserName: 'Carolina Vega',
    companyName: 'Restaurante La Parrilla',
    category: 'Gastronomía',
    location: 'Mendoza',
    budget: 500,
    budgetType: 'mensual',
    description: 'Restaurante tradicional busca sponsorear segmento de recetas. Idealmente un espacio diario donde podamos compartir recetas y promociones del día.',
    targetAudience: 'Amas de casa y familias, 30-55',
    preferredFormat: 'Segmento sponsoreado diario',
    duration: '6 meses',
    startDate: '2026-07-15',
    status: 'nueva',
    postedDate: '2026-06-15',
    proposals: 2,
    contactEmail: 'carolina@laparrilla.com',
    contactPhone: '+54 261 555-0202',
  },
  {
    id: 3,
    advertiserName: 'Federico Rojas',
    companyName: 'AutoRepuestos Mendoza',
    category: 'Automotor',
    location: 'Mendoza',
    budget: 1200,
    budgetType: 'mensual',
    description: 'Cadena de repuestos con 5 sucursales busca pauta en radio para aumentar tráfico a sucursales. Interesados en menciones durante programas matutinos de alto rating.',
    targetAudience: 'Hombres 25-50, conductores',
    preferredFormat: 'Menciones en programa matutino',
    duration: '4 meses',
    startDate: '2026-07-01',
    status: 'nueva',
    postedDate: '2026-06-19',
    proposals: 1,
    contactEmail: 'federico@autorepuestos.com',
    contactPhone: '+54 261 555-0303',
  },
  {
    id: 4,
    advertiserName: 'Valentina Sosa',
    companyName: 'Gimnasio PowerFit',
    category: 'Fitness',
    location: 'San Rafael',
    budget: 600,
    budgetType: 'mensual',
    description: 'Nueva cadena de gimnasios en San Rafael busca darse a conocer. Queremos menciones en programas de la tarde y sorteo de pases libres.',
    targetAudience: 'Jóvenes y adultos 18-40, fitness y bienestar',
    preferredFormat: 'Menciones + Sorteos',
    duration: '3 meses',
    startDate: '2026-08-01',
    status: 'nueva',
    postedDate: '2026-06-17',
    proposals: 0,
    contactEmail: 'valentina@powerfit.com',
    contactPhone: '+54 260 444-0101',
  },
  {
    id: 5,
    advertiserName: 'Diego Altamirano',
    companyName: 'Seguros La Protección',
    category: 'Seguros',
    location: 'Mendoza',
    budget: 1500,
    budgetType: 'mensual',
    description: 'Aseguradora líder en la región busca sponsorear noticiero central. Necesitamos cápsulas informativas de 30 segundos durante el noticiero de la tarde.',
    targetAudience: 'Adultos 30-60, profesionales',
    preferredFormat: 'Cápsulas en noticiero',
    duration: '6 meses',
    startDate: '2026-08-01',
    status: 'nueva',
    postedDate: '2026-06-20',
    proposals: 1,
    contactEmail: 'diego@segurosproteccion.com',
    contactPhone: '+54 261 555-0404',
  },
  {
    id: 6,
    advertiserName: 'Luciana Paz',
    companyName: 'Bodega Trapiche',
    category: 'Vitivinicultura',
    location: 'Maipú',
    budget: 2000,
    budgetType: 'mensual',
    description: 'Bodega exportadora busca fortalecer presencia local. Queremos sponsorear programa de fin de semana + presencia en todos los eventos de la radio durante la temporada de vendimia.',
    targetAudience: 'Adultos 25-55, turistas y locales',
    preferredFormat: 'Programa + Eventos',
    duration: '12 meses',
    startDate: '2026-09-01',
    status: 'analizando',
    postedDate: '2026-06-10',
    proposals: 3,
    contactEmail: 'luciana@trapiche.com',
    contactPhone: '+54 261 555-0505',
  },
  {
    id: 7,
    advertiserName: 'Gonzalo Méndez',
    companyName: 'Hotel Termas Cacheuta',
    category: 'Turismo',
    location: 'Cacheuta',
    budget: 900,
    budgetType: 'mensual',
    description: 'Hotel spa de montaña busca atraer turismo regional. Nos interesa pauta en radio para promocionar escapadas de fin de semana y paquetes de bienestar.',
    targetAudience: 'Parejas y familias, 25-50, turismo regional',
    preferredFormat: 'Menciones + Concursos (estadías)',
    duration: '4 meses',
    startDate: '2026-07-15',
    status: 'nueva',
    postedDate: '2026-06-16',
    proposals: 0,
    contactEmail: 'gonzalo@termascacheuta.com',
    contactPhone: '+54 261 555-0606',
  },
  {
    id: 8,
    advertiserName: 'Romina Castillo',
    companyName: 'Universidad de Mendoza',
    category: 'Educación',
    location: 'Mendoza',
    budget: 1100,
    budgetType: 'mensual',
    description: 'Universidad privada busca promocionar inscripciones para el ciclo 2027. Necesitamos menciones e inserción de banners en sitio web de la radio.',
    targetAudience: 'Jóvenes 17-22 y padres 40-55',
    preferredFormat: 'Menciones al aire + Banners web',
    duration: '2 meses',
    startDate: '2026-10-01',
    status: 'nueva',
    postedDate: '2026-06-18',
    proposals: 0,
    contactEmail: 'romina@umendoza.edu.ar',
    contactPhone: '+54 261 555-0707',
  },
  {
    id: 9,
    advertiserName: 'Pablo Quiroga',
    companyName: 'Supermercado Átomo',
    category: 'Retail',
    location: 'San Martín',
    budget: 700,
    budgetType: 'mensual',
    description: 'Cadena de supermercados del Este provincial busca aumentar ventas con pauta en radio. Ofertas semanales y promociones especiales.',
    targetAudience: 'Amas de casa y familias, 25-55',
    preferredFormat: 'Menciones diarias con ofertas',
    duration: '6 meses',
    startDate: '2026-07-01',
    status: 'nueva',
    postedDate: '2026-06-14',
    proposals: 2,
    contactEmail: 'pablo@superatomo.com',
    contactPhone: '+54 263 444-0202',
  },
  {
    id: 10,
    advertiserName: 'Andrea Lagos',
    companyName: 'Farmacia Dr. Ahorro',
    category: 'Salud',
    location: 'Godoy Cruz',
    budget: 450,
    budgetType: 'mensual',
    description: 'Cadena de farmacias con 8 sucursales busca pauta accesible para radio. Segmentos de salud y bienestar, consejos farmacéuticos.',
    targetAudience: 'Adultos 35-65, interesados en salud',
    preferredFormat: 'Micros de salud + Menciones',
    duration: '3 meses',
    startDate: '2026-08-01',
    status: 'nueva',
    postedDate: '2026-06-12',
    proposals: 1,
    contactEmail: 'andrea@drahoro.com',
    contactPhone: '+54 261 555-0808',
  },
  {
    id: 11,
    advertiserName: 'Javier Olmedo',
    companyName: 'Constructora Cuyo',
    category: 'Construcción',
    location: 'Mendoza',
    budget: 2500,
    budgetType: 'mensual',
    description: 'Constructora con nuevos desarrollos inmobiliarios busca presencia importante en radio. Programa completo sponsoreado + banners + eventos. Presupuesto flexible.',
    targetAudience: 'Adultos 30-55, inversores y familias',
    preferredFormat: 'Programa + Banners + Eventos',
    duration: '12 meses',
    startDate: '2026-09-01',
    status: 'analizando',
    postedDate: '2026-06-08',
    proposals: 4,
    contactEmail: 'javier@constructoracuyo.com',
    contactPhone: '+54 261 555-0909',
  },
  {
    id: 12,
    advertiserName: 'Natalia Herrera',
    companyName: 'Óptica Visión',
    category: 'Salud',
    location: 'Mendoza',
    budget: 350,
    budgetType: 'mensual',
    description: 'Óptica con 3 sucursales busca menciones en radio para dar a conocer promociones de lentes y anteojos de sol para la temporada.',
    targetAudience: 'Adultos 25-60, conductores',
    preferredFormat: 'Menciones en vivo',
    duration: '2 meses',
    startDate: '2026-07-01',
    status: 'cerrada',
    postedDate: '2026-05-20',
    proposals: 5,
    contactEmail: 'natalia@opticavision.com',
    contactPhone: '+54 261 555-1010',
  },
];

export const categories: string[] = [
  'Todas',
  'Bebidas',
  'Gastronomía',
  'Automotor',
  'Fitness',
  'Seguros',
  'Vitivinicultura',
  'Turismo',
  'Educación',
  'Retail',
  'Salud',
  'Construcción',
];

export const locations: string[] = [
  'Todas',
  'Mendoza',
  'Godoy Cruz',
  'Maipú',
  'San Rafael',
  'San Martín',
  'Cacheuta',
];

export const budgetRanges: { label: string; value: BudgetRange }[] = [
  { label: 'Todos', value: 'todos' },
  { label: 'Menos de $500', value: 'menos-500' },
  { label: '$500 - $1.500', value: '500-1500' },
  { label: '$1.500 - $3.000', value: '1500-3000' },
  { label: 'Más de $3.000', value: 'mas-3000' },
];

export const statusFilters: { label: string; value: RequestStatus }[] = [
  { label: 'Todas', value: 'todas' },
  { label: 'Nuevas', value: 'nueva' },
  { label: 'Analizando', value: 'analizando' },
  { label: 'Propuesta enviada', value: 'propuesta-enviada' },
  { label: 'Cerradas', value: 'cerrada' },
];

export interface MarketplaceProposal {
  id: number;
  listingId: number;
  radioName: string;
  radioFrequency: string;
  radioAvatar: string;
  price: number;
  duration: string;
  benefits: string[];
  message: string;
  status: 'pendiente' | 'aceptada' | 'rechazada';
  submittedAt: string;
}

export interface AdvertiserListing {
  id: number;
  company: string;
  companyLogo: string;
  logo: string;
  description: string;
  objective: string;
  location: string;
  budget: string;
  category: string;
  status: 'abierta' | 'negociacion' | 'contratada' | 'finalizada';
  proposals: MarketplaceProposal[];
  commissionRate: number;
  createdAt: string;
  closesAt: string;
  contactName: string;
  contactEmail: string;
}

export const categoryLabels: Record<string, string> = {
  Bebidas: 'Bebidas',
  Gastronomía: 'Gastronomía',
  Automotor: 'Automotor',
  Fitness: 'Fitness',
  Seguros: 'Seguros',
  Vitivinicultura: 'Vitivinicultura',
  Turismo: 'Turismo',
  Educación: 'Educación',
  Retail: 'Retail',
  Salud: 'Salud',
  Construcción: 'Construcción',
};

export const categoryIcons: Record<string, string> = {
  Bebidas: 'ri-goblet-line',
  Gastronomía: 'ri-restaurant-line',
  Automotor: 'ri-car-line',
  Fitness: 'ri-heart-pulse-line',
  Seguros: 'ri-shield-check-line',
  Vitivinicultura: 'ri-goblet-line',
  Turismo: 'ri-suitcase-line',
  Educación: 'ri-book-open-line',
  Retail: 'ri-shopping-bag-line',
  Salud: 'ri-medicine-bottle-line',
  Construcción: 'ri-building-line',
};

export const statusLabels: Record<string, string> = {
  abierta: 'Abierta',
  negociacion: 'En Negociación',
  contratada: 'Contratada',
  finalizada: 'Finalizada',
};

export const marketplaceListings: AdvertiserListing[] = [
  {
    id: 1,
    company: 'Cerveza Andes',
    companyLogo: 'CA',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20brewery%20brand%20logo%20with%20mountain%20silhouette%2C%20golden%20amber%20tones%2C%20clean%20minimalist%20design%2C%20warm%20background%2C%20premium%20craft%20aesthetic%20with%20soft%20lighting&width=200&height=200&seq=market-logo-ca&orientation=squarish',
    description: 'Buscamos presencia en radio local para campaña de verano. Necesitamos menciones en vivo y presencia en eventos de la radio. Público objetivo: jóvenes 20-35 años. Presupuesto flexible para la propuesta correcta.',
    objective: 'Brand Awareness + Eventos',
    location: 'Mendoza',
    budget: '$800/mes',
    category: 'Bebidas',
    status: 'abierta',
    proposals: [],
    commissionRate: 12,
    createdAt: '2026-06-18',
    closesAt: '2026-07-18',
    contactName: 'Martín Gutiérrez',
    contactEmail: 'martin@cervezandes.com',
  },
  {
    id: 2,
    company: 'Restaurante La Parrilla',
    companyLogo: 'LP',
    logo: 'https://readdy.ai/api/search-image?query=Restaurant%20brand%20logo%20with%20grill%20and%20flame%20motif%2C%20warm%20terracotta%20and%20amber%20colors%2C%20clean%20minimalist%20design%2C%20soft%20warm%20background%2C%20gourmet%20aesthetic&width=200&height=200&seq=market-logo-lp&orientation=squarish',
    description: 'Restaurante tradicional busca sponsorear segmento de recetas. Idealmente un espacio diario donde podamos compartir recetas y promociones del día. Buscamos radio con buen alcance en horario matutino.',
    objective: 'Segmento Patrocinado',
    location: 'Mendoza',
    budget: '$500/mes',
    category: 'Gastronomía',
    status: 'negociacion',
    proposals: [
      { id: 101, listingId: 2, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 480, duration: '6 meses', benefits: ['Segmento diario de 3 min', '2 menciones por hora', 'Sorteos mensuales'], message: 'Somos la radio líder en el segmento matutino. Nuestro programa de recetas tiene excelente audiencia y encaja perfecto con La Parrilla.', status: 'pendiente', submittedAt: '2026-06-16' },
      { id: 102, listingId: 2, radioName: 'Estéreo Capital', radioFrequency: '101.1 FM', radioAvatar: '', price: 520, duration: '4 meses', benefits: ['Espacio de 5 min', 'Recetas en vivo con chef', 'Promociones del día'], message: 'Contamos con estudio equipado para transmisiones culinarias en vivo. Audiencia premium.', status: 'pendiente', submittedAt: '2026-06-17' },
    ],
    commissionRate: 10,
    createdAt: '2026-06-15',
    closesAt: '2026-07-15',
    contactName: 'Carolina Vega',
    contactEmail: 'carolina@laparrilla.com',
  },
  {
    id: 3,
    company: 'AutoRepuestos Mendoza',
    companyLogo: 'AR',
    logo: 'https://readdy.ai/api/search-image?query=Auto%20parts%20brand%20logo%20with%20gear%20and%20wrench%20symbols%2C%20dark%20charcoal%20and%20orange%20accents%2C%20clean%20industrial%20design%2C%20neutral%20background%2C%20professional%20automotive%20aesthetic&width=200&height=200&seq=market-logo-ar&orientation=squarish',
    description: 'Cadena de repuestos con 5 sucursales busca pauta en radio para aumentar tráfico a sucursales. Interesados en menciones durante programas matutinos de alto rating. Buscamos radio con buena llegada al público conductor.',
    objective: 'Tráfico a Sucursales',
    location: 'Mendoza',
    budget: '$1.200/mes',
    category: 'Automotor',
    status: 'abierta',
    proposals: [
      { id: 103, listingId: 3, radioName: 'Radio Industria', radioFrequency: '88.7 FM', radioAvatar: '', price: 1100, duration: '4 meses', benefits: ['Menciones cada 30 min', 'Cápsulas técnicas', 'Sorteo de service gratis'], message: 'Nuestra audiencia es 70% masculina, conductores. Perfecta para AutoRepuestos.', status: 'pendiente', submittedAt: '2026-06-20' },
    ],
    commissionRate: 15,
    createdAt: '2026-06-19',
    closesAt: '2026-07-19',
    contactName: 'Federico Rojas',
    contactEmail: 'federico@autorepuestos.com',
  },
  {
    id: 4,
    company: 'Gimnasio PowerFit',
    companyLogo: 'PF',
    logo: 'https://readdy.ai/api/search-image?query=Fitness%20gym%20brand%20logo%20with%20dynamic%20silhouette%2C%20electric%20green%20and%20black%20colors%2C%20clean%20minimalist%20design%2C%20bright%20clean%20background%2C%20modern%20athletic%20aesthetic&width=200&height=200&seq=market-logo-pf&orientation=squarish',
    description: 'Nueva cadena de gimnasios en San Rafael busca darse a conocer. Queremos menciones en programas de la tarde y sorteo de pases libres. Nos interesa llegar al público joven y adulto activo.',
    objective: 'Reconocimiento de Marca',
    location: 'San Rafael',
    budget: '$600/mes',
    category: 'Fitness',
    status: 'abierta',
    proposals: [],
    commissionRate: 10,
    createdAt: '2026-06-17',
    closesAt: '2026-07-17',
    contactName: 'Valentina Sosa',
    contactEmail: 'valentina@powerfit.com',
  },
  {
    id: 5,
    company: 'Seguros La Protección',
    companyLogo: 'SP',
    logo: 'https://readdy.ai/api/search-image?query=Insurance%20company%20brand%20logo%20with%20shield%20symbol%2C%20navy%20blue%20and%20gold%20colors%2C%20clean%20professional%20design%2C%20light%20neutral%20background%2C%20corporate%20trustworthy%20aesthetic&width=200&height=200&seq=market-logo-sp&orientation=squarish',
    description: 'Aseguradora líder en la región busca sponsorear noticiero central. Necesitamos cápsulas informativas de 30 segundos durante el noticiero de la tarde. Presupuesto anual disponible para la radio correcta.',
    objective: 'Noticiero Patrocinado',
    location: 'Mendoza',
    budget: '$1.500/mes',
    category: 'Seguros',
    status: 'negociacion',
    proposals: [
      { id: 104, listingId: 5, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 1400, duration: '6 meses', benefits: ['Cápsulas de 30 seg', '2 por emisión', 'Branding en estudio'], message: 'Nuestro noticiero es el más escuchado de la región. Audiencia adulta profesional.', status: 'pendiente', submittedAt: '2026-06-21' },
    ],
    commissionRate: 15,
    createdAt: '2026-06-20',
    closesAt: '2026-07-20',
    contactName: 'Diego Altamirano',
    contactEmail: 'diego@segurosproteccion.com',
  },
  {
    id: 6,
    company: 'Bodega Trapiche',
    companyLogo: 'BT',
    logo: 'https://readdy.ai/api/search-image?query=Winery%20brand%20logo%20with%20grapevine%20and%20wine%20glass%20motif%2C%20deep%20burgundy%20and%20gold%20colors%2C%20elegant%20minimalist%20design%2C%20warm%20earthy%20background%2C%20premium%20wine%20aesthetic&width=200&height=200&seq=market-logo-bt&orientation=squarish',
    description: 'Bodega exportadora busca fortalecer presencia local. Queremos sponsorear programa de fin de semana + presencia en todos los eventos de la radio durante la temporada de vendimia. Contrato anual.',
    objective: 'Programa + Eventos',
    location: 'Maipú',
    budget: '$2.000/mes',
    category: 'Vitivinicultura',
    status: 'negociacion',
    proposals: [
      { id: 105, listingId: 6, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 1900, duration: '12 meses', benefits: ['Programa completo', 'Presencia en 5 eventos', 'Menciones diarias', 'Cobertura Vendimia'], message: 'Somos la radio de la Vendimia. Cobertura total de todos los eventos vitivinícolas.', status: 'pendiente', submittedAt: '2026-06-12' },
      { id: 106, listingId: 6, radioName: 'Estéreo Capital', radioFrequency: '101.1 FM', radioAvatar: '', price: 2100, duration: '12 meses', benefits: ['Programa premium', 'Eventos VIP', 'Degustaciones al aire', 'Entrevistas exclusivas'], message: 'Nuestra audiencia es el target premium que busca Trapiche. Somos la radio del vino.', status: 'pendiente', submittedAt: '2026-06-13' },
      { id: 107, listingId: 6, radioName: 'Radio Industria', radioFrequency: '88.7 FM', radioAvatar: '', price: 1750, duration: '12 meses', benefits: ['Programa semanal', 'Eventos masivos', 'Sorteos de vinos', 'Notas de vendimia'], message: 'Llegamos a todo el público trabajador de la vitivinicultura. Cercanía total con la industria.', status: 'pendiente', submittedAt: '2026-06-14' },
    ],
    commissionRate: 18,
    createdAt: '2026-06-10',
    closesAt: '2026-07-10',
    contactName: 'Luciana Paz',
    contactEmail: 'luciana@trapiche.com',
  },
  {
    id: 7,
    company: 'Hotel Termas Cacheuta',
    companyLogo: 'TC',
    logo: 'https://readdy.ai/api/search-image?query=Hotel%20spa%20brand%20logo%20with%20mountain%20and%20thermal%20water%20symbols%2C%20teal%20and%20warm%20beige%20colors%2C%20clean%20minimalist%20design%2C%20soft%20natural%20background%2C%20luxury%20wellness%20aesthetic&width=200&height=200&seq=market-logo-tc&orientation=squarish',
    description: 'Hotel spa de montaña busca atraer turismo regional. Nos interesa pauta en radio para promocionar escapadas de fin de semana y paquetes de bienestar. Ideal para radios con alcance en Gran Mendoza.',
    objective: 'Turismo + Paquetes',
    location: 'Cacheuta',
    budget: '$900/mes',
    category: 'Turismo',
    status: 'abierta',
    proposals: [],
    commissionRate: 12,
    createdAt: '2026-06-16',
    closesAt: '2026-07-16',
    contactName: 'Gonzalo Méndez',
    contactEmail: 'gonzalo@termascacheuta.com',
  },
  {
    id: 8,
    company: 'Universidad de Mendoza',
    companyLogo: 'UM',
    logo: 'https://readdy.ai/api/search-image?query=University%20brand%20logo%20with%20book%20and%20torch%20symbols%2C%20royal%20blue%20and%20white%20colors%2C%20clean%20academic%20design%2C%20light%20neutral%20background%2C%20prestigious%20educational%20aesthetic&width=200&height=200&seq=market-logo-um&orientation=squarish',
    description: 'Universidad privada busca promocionar inscripciones para el ciclo 2027. Necesitamos menciones e inserción de banners en sitio web de la radio. Campaña corta pero intensiva.',
    objective: 'Inscripciones 2027',
    location: 'Mendoza',
    budget: '$1.100/mes',
    category: 'Educación',
    status: 'abierta',
    proposals: [],
    commissionRate: 10,
    createdAt: '2026-06-18',
    closesAt: '2026-07-18',
    contactName: 'Romina Castillo',
    contactEmail: 'romina@umendoza.edu.ar',
  },
  {
    id: 9,
    company: 'Supermercado Átomo',
    companyLogo: 'SA',
    logo: 'https://readdy.ai/api/search-image?query=Supermarket%20brand%20logo%20with%20shopping%20cart%20symbol%2C%20red%20and%20yellow%20colors%2C%20clean%20minimalist%20design%2C%20white%20background%2C%20friendly%20family%20retail%20aesthetic&width=200&height=200&seq=market-logo-sa&orientation=squarish',
    description: 'Cadena de supermercados del Este provincial busca aumentar ventas con pauta en radio. Ofertas semanales y promociones especiales. Buscamos radio que cubra San Martín y alrededores.',
    objective: 'Ventas + Promociones',
    location: 'San Martín',
    budget: '$700/mes',
    category: 'Retail',
    status: 'negociacion',
    proposals: [
      { id: 108, listingId: 9, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 650, duration: '6 meses', benefits: ['Menciones diarias', 'Ofertas del día', 'Sorteos de compras'], message: 'Alcance comprobado en zona Este. Nuestra audiencia es ama de casa, target directo.', status: 'pendiente', submittedAt: '2026-06-15' },
      { id: 109, listingId: 9, radioName: 'Estéreo Capital', radioFrequency: '101.1 FM', radioAvatar: '', price: 720, duration: '6 meses', benefits: ['Segmento de ofertas', 'Menciones cada hora', 'Promociones exclusivas'], message: 'Llegamos a todo el Gran Mendoza, incluyendo zona Este. Alta fidelidad de audiencia.', status: 'pendiente', submittedAt: '2026-06-16' },
    ],
    commissionRate: 12,
    createdAt: '2026-06-14',
    closesAt: '2026-07-14',
    contactName: 'Pablo Quiroga',
    contactEmail: 'pablo@superatomo.com',
  },
  {
    id: 10,
    company: 'Farmacia Dr. Ahorro',
    companyLogo: 'DA',
    logo: 'https://readdy.ai/api/search-image?query=Pharmacy%20brand%20logo%20with%20cross%20and%20leaf%20symbols%2C%20green%20and%20white%20colors%2C%20clean%20minimalist%20design%2C%20light%20clean%20background%2C%20trustworthy%20healthcare%20aesthetic&width=200&height=200&seq=market-logo-da&orientation=squarish',
    description: 'Cadena de farmacias con 8 sucursales busca pauta accesible para radio. Segmentos de salud y bienestar, consejos farmacéuticos. Ideal para radios familiares con audiencia adulta.',
    objective: 'Salud + Bienestar',
    location: 'Godoy Cruz',
    budget: '$450/mes',
    category: 'Salud',
    status: 'abierta',
    proposals: [
      { id: 110, listingId: 10, radioName: 'Radio Industria', radioFrequency: '88.7 FM', radioAvatar: '', price: 420, duration: '3 meses', benefits: ['Micros de salud', 'Consejos farmacéuticos', 'Promociones semanales'], message: 'Nuestra audiencia valora los contenidos de salud. Segmento perfecto para farmacia.', status: 'pendiente', submittedAt: '2026-06-13' },
    ],
    commissionRate: 8,
    createdAt: '2026-06-12',
    closesAt: '2026-07-12',
    contactName: 'Andrea Lagos',
    contactEmail: 'andrea@drahoro.com',
  },
  {
    id: 11,
    company: 'Constructora Cuyo',
    companyLogo: 'CC',
    logo: 'https://readdy.ai/api/search-image?query=Construction%20company%20brand%20logo%20with%20building%20and%20crane%20symbols%2C%20dark%20gray%20and%20orange%20colors%2C%20clean%20industrial%20design%2C%20neutral%20background%2C%20professional%20corporate%20aesthetic&width=200&height=200&seq=market-logo-cc&orientation=squarish',
    description: 'Constructora con nuevos desarrollos inmobiliarios busca presencia importante en radio. Programa completo sponsoreado + banners + eventos. Presupuesto flexible para paquete integral anual.',
    objective: 'Desarrollos Inmobiliarios',
    location: 'Mendoza',
    budget: '$2.500/mes',
    category: 'Construcción',
    status: 'negociacion',
    proposals: [
      { id: 111, listingId: 11, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 2400, duration: '12 meses', benefits: ['Programa completo', 'Banners web', 'Eventos inaugurales', 'Entrevistas exclusivas'], message: 'Paquete integral: radio + web + eventos. Máxima exposición para los desarrollos de Cuyo.', status: 'pendiente', submittedAt: '2026-06-09' },
      { id: 112, listingId: 11, radioName: 'Estéreo Capital', radioFrequency: '101.1 FM', radioAvatar: '', price: 2600, duration: '12 meses', benefits: ['Programa prime', 'Banners premium', 'Eventos VIP', 'Cobertura total'], message: 'Nuestra audiencia es inversora. El target exacto para desarrollos inmobiliarios.', status: 'pendiente', submittedAt: '2026-06-10' },
      { id: 113, listingId: 11, radioName: 'Radio Industria', radioFrequency: '88.7 FM', radioAvatar: '', price: 2200, duration: '12 meses', benefits: ['Programa semanal', 'Banners', 'Ferias de construcción', 'Notas de obra'], message: 'Conexión directa con el rubro de la construcción. Audiencia obrera y profesional.', status: 'pendiente', submittedAt: '2026-06-11' },
      { id: 114, listingId: 11, radioName: 'Radio Andina FM', radioFrequency: '96.1 FM', radioAvatar: '', price: 2300, duration: '12 meses', benefits: ['Programa de fin de semana', 'Banners destacados', 'Eventos de lanzamiento'], message: 'Nueva radio con crecimiento explosivo. Oportunidad de ser sponsor fundacional.', status: 'pendiente', submittedAt: '2026-06-12' },
    ],
    commissionRate: 20,
    createdAt: '2026-06-08',
    closesAt: '2026-07-08',
    contactName: 'Javier Olmedo',
    contactEmail: 'javier@constructoracuyo.com',
  },
  {
    id: 12,
    company: 'Óptica Visión',
    companyLogo: 'OV',
    logo: 'https://readdy.ai/api/search-image?query=Optical%20store%20brand%20logo%20with%20glasses%20symbol%2C%20light%20blue%20and%20silver%20colors%2C%20clean%20minimalist%20design%2C%20light%20neutral%20background%2C%20professional%20eyewear%20aesthetic&width=200&height=200&seq=market-logo-ov&orientation=squarish',
    description: 'Óptica con 3 sucursales busca menciones en radio para dar a conocer promociones de lentes y anteojos de sol para la temporada. Campaña corta de verano.',
    objective: 'Lentes + Promociones',
    location: 'Mendoza',
    budget: '$350/mes',
    category: 'Salud',
    status: 'contratada',
    proposals: [
      { id: 115, listingId: 12, radioName: 'Radio Éxito FM', radioFrequency: '94.3 FM', radioAvatar: '', price: 350, duration: '2 meses', benefits: ['Menciones diarias', 'Promociones exclusivas', 'Sorteo de lentes'], message: 'Propuesta ajustada a presupuesto. Máximo alcance por el menor costo.', status: 'aceptada', submittedAt: '2026-05-22' },
      { id: 116, listingId: 12, radioName: 'Estéreo Capital', radioFrequency: '101.1 FM', radioAvatar: '', price: 380, duration: '2 meses', benefits: ['Menciones premium', 'Segmento de moda', 'Descuentos exclusivos'], message: 'Nuestra audiencia premium valora la moda y los accesorios. Perfecto para óptica.', status: 'rechazada', submittedAt: '2026-05-23' },
      { id: 117, listingId: 12, radioName: 'Radio Andina FM', radioFrequency: '96.1 FM', radioAvatar: '', price: 320, duration: '2 meses', benefits: ['Menciones económicas', 'Promos diarias'], message: 'Opción económica con buena cobertura en Mendoza.', status: 'rechazada', submittedAt: '2026-05-24' },
    ],
    commissionRate: 8,
    createdAt: '2026-05-20',
    closesAt: '2026-06-20',
    contactName: 'Natalia Herrera',
    contactEmail: 'natalia@opticavision.com',
  },
];